const fetch = require('node-fetch')
const chained = require('./chained')
const Requestor = require('./request')

const req = new Requestor(fetch)

const method = 'GET'
const path = 'https://api.github.com' + chained('','').repos('philschatz', 'octokat.js').issues._path
const data = null
const isRaw = false
const isBase64 = false
const isBoolean = false
const contentType = null
const acceptHeader = null

req.request(method, path, data, isRaw, isBase64, isBoolean, contentType, acceptHeader)
.then(({value, request, response, additional}) => {
  console.log('REQUEST', request)
  console.log('RESPONSE', response)
  console.log('ADDITIONAL', additional)
  console.log('RESPONSE_HEADERS', JSON.stringify(response.headers));
})
